import { render } from "./Statistics.vue?vue&type=template&id=85a83b24"
import script from "./Statistics.vue?vue&type=script&scoped=true&lang=js"
export * from "./Statistics.vue?vue&type=script&scoped=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__